// removed by extract-text-webpack-plugin
module.exports = {"link":"_2ZJ2TxBVfvuhn7NnjloRng","link_legal":"_31fqNGbgEjt1u1QWiDPDE8"};